module.exports = __webpack_public_path__ + "Sophiralou.webp?190739c551528fa9a36f08cee1f514ef";


//////////////////
// WEBPACK FOOTER
// ./public/creator-avatar/Sophiralou.webp
// module id = 161
// module chunks = 0